export enum Environment {
  staging = 'staging',
  demo = 'demo',
  production = 'production',
}

export enum HeaderSearchAssetType {
  all = 'all',
  prospects = 'prospects',
  organizations = 'organizations',
  deals = 'deals',
}

export enum SortDirection {
  asc = 'asc',
  desc = 'desc',
}

export enum FormDialogType {
  prospect = 'Prospect',
  organization = 'Organization',
  deal = 'Deal',
  task = 'Task',
}

export enum PhoneNumberType {
  work = 'workPhone',
  home = 'homePhone',
  mobile = 'mobilePhone',
}
export enum TimelineFilter {
  task = 'task',
  note = 'note',
}
